import type { TOC } from '@ember/component/template-only'
import type RexSpellingProgressAveragesRoute from 'district-ui-client/reporting/ui-scope/rex/spelling-progress/averages/route'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { ChartsCourseProgressAverages } from 'district-ui-client/components/charts/course-progress/averages/component'
import { not } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import { Precinct } from 'district-ui-client/domain/precinct'

interface Signature {
  Args: {
    model: ModelFor<RexSpellingProgressAveragesRoute>
  }
}

export const RexSpellingProgressAveragesRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.spellingProgressAverages}}>
    {{#each @model.spellingProgressAverages as |gradeData|}}
      <div class="detailed-chart-wrapper">
        <ChartsCourseProgressAverages
          class="h-full"
          @data={{gradeData}}
          @precinct={{Precinct.REX_SPELLING}}
          @tooltip={{t "reporting.tooltips.spellingProgressAverages"}}
          @title={{t "reporting.chartTitles.spellingProgressAverages"}}
        />
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(RexSpellingProgressAveragesRouteTemplate)
